import type {
  KPIConsecutiveFailAlertItem,
  KPIConsecutiveFailScanResponse,
} from '@/types/kpi-consecutive-fail';

export const KPI_CONSECUTIVE_FAIL_PATH = '/thong-ke-kpi-khong-dat';

export type KPIFailSource = 'self' | 'employee' | 'child_dept';

export type KPIFailAlertRow = KPIConsecutiveFailAlertItem & {
  source: KPIFailSource;
  ownerGroupName?: string;
};

export function kpiFailReasonLabel(
  t: (k: string, d: string) => string,
  reason?: string,
): string {
  if (reason === 'overdue_unreported') {
    return t('bsc.msg.kpi_fail_overdue', 'Quá hạn chưa báo cáo');
  }
  return t('bsc.msg.kpi_fail_performance', 'Không đạt hiệu suất');
}

export function flattenKPIFailAlerts(
  data?: KPIConsecutiveFailScanResponse | null,
): KPIFailAlertRow[] {
  if (!data) return [];
  return [
    ...data.self.map((item) => ({
      ...item,
      source: 'self' as const,
      ownerGroupName: item.tenPhuTrach || undefined,
    })),
    ...data.employees.flatMap((g) =>
      g.alerts.map((item) => ({
        ...item,
        source: 'employee' as const,
        ownerGroupName: g.ten || g.id,
      })),
    ),
    ...data.childDepts.flatMap((g) =>
      g.alerts.map((item) => ({
        ...item,
        source: 'child_dept' as const,
        ownerGroupName: g.ten || g.id,
      })),
    ),
  ];
}

export function kpiFailSourceLabel(
  t: (k: string, d: string) => string,
  source: KPIFailSource,
): string {
  if (source === 'employee') return t('bsc.label.nhan_vien', 'Nhân viên');
  if (source === 'child_dept') return t('bsc.label.phong_ban_con', 'Phòng ban trực thuộc');
  return t('bsc.label.phong_ban_hien_tai', 'Phòng ban / công ty hiện tại');
}
